import 'public/js/sweetalert';
import Cookies from 'js-cookie';
import 'core-js';
import 'public/style.scss'
import 'public/main'
import 'public/js/video'
import 'public/js/ani'
import ahoy from "ahoy.js"
import Rails from "@rails/ujs"
Rails.start();

window.jQuery = $;
window.$ = $;
window.Cookies = Cookies;

